<template>
  <template v-if="stacked">
    <div class="email-validator stacked">
      <div
        class="input-group mt-5 w-100"
        v-bind:class="{ 'red-border': email_exist }"
      >
        <input
          type="text"
          class="form-control"
          v-model="mail"
          @keyup.enter="validateEmail"
          :placeholder="$t('landing.be_part_of.emailPlaceholder')"
        />
      </div>
      <button
        @click="validateEmail"
        role="link"
        class="btn btn-danger w-100 py-2 mt-3"
        type="button"
        :disabled="isValidMail"
      >
        {{ $t("landing.be_part_of.startTrial") }}
      </button>
      <p class="text-error p-1" v-if="email_exist">
        {{ $t("register.account_exists") }}
        <router-link :to="{ name: 'login', query: { email: mail } }">{{
          $t("navbar.login")
        }}</router-link>
      </p>
    </div>
  </template>
  <template v-else>
    <template v-if="true">
      <router-link
        class="btn btn-danger d-block my-5 w-75 mx-auto"
        :to="{ name: 'register' }"
      >
        {{ $t("landing.be_part_of.startTrial") }}
      </router-link>
    </template>
    <template v-else>
      <div class="email-validator px-3">
        <div
          class="input-group mt-5 w-100"
          v-bind:class="{ 'red-border': email_exist }"
        >
          <input
            type="text"
            class="form-control"
            v-model="mail"
            @keyup.enter="validateEmail"
            :placeholder="$t('landing.be_part_of.emailPlaceholder')"
          />

          <button
            @click="validateEmail"
            role="link"
            class="btn btn-danger"
            type="button"
            :disabled="isValidMail"
          >
            {{ $t("landing.be_part_of.startTrial") }}
          </button>
        </div>
        <p class="text-error p-1" v-if="email_exist">
          {{ $t("register.account_exists") }}
          <router-link :to="{ name: 'login', query: { email: mail } }">{{
            $t("navbar.login")
          }}</router-link>
        </p>
      </div>
    </template>
  </template>
</template>

<script>
import { OrizonApiClient } from "@/services/OrizonApiClient";
const apiClient = new OrizonApiClient();
export default {
  name: "EmailValidator",
  props: {
    stack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mail: null,
      email_exist: false,
    };
  },
  computed: {
    mobile() {
      return this.isMobile();
    },
    stacked() {
      return this.stack;
    },
    isValidMail() {
      let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !this.mail || !pattern.test(this.mail);
    },
  },
  methods: {
    validateEmail() {
      apiClient.validateEmail(this.mail).then((response) => {
        if (!response.data.error) {
          if (response.data.status === false) {
            this.$router.push({
              name: "register",
              query: { email: this.mail },
            });
          } else {
            this.email_exist = true;
          }
          console.info("navigate", response);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";

.email-validator {
  .input-group {
    padding: 0.2em;
    border-radius: 14px;
    background: linear-gradient(
      342.85deg,
      #2e3a50 6.38%,
      rgba(11, 16, 25, 0) 127.79%
    );
    border-top: 1px solid #3f5556;
    border-left: 1px solid #4f6667;
    backdrop-filter: blur(16px);
    input {
      background-color: transparent;
      padding: 1.6em;
      border: none;
      &::placeholder {
        color: white;
      }
    }
    button {
      background: $red;
      padding: 0.5em 2em;
    }
  }

  .text-error {
    a {
      color: #fff;
      font-weight: 400;
      font-size: 0.9em;
    }
  }
}
@media (max-width: 767px) {
  .input-group {
    input {
      padding: 0.3em 1em !important;
      font-size: 1em;
      font-weight: light;
    }
    button {
      padding: 0.3em 1em !important;
      font-size: 1em;
    }
  }
  .text-error {
    backdrop-filter: blur(10px);
    font-size: 0.8em;
    text-align: center;
    padding: 1em !important;
    display: block;
  }
}
</style>
